// extracted by mini-css-extract-plugin
export default {"table":"MicropileCompressionSummary_table__WQDy0","value":"MicropileCompressionSummary_value__2OzOs","underline":"MicropileCompressionSummary_underline__4XHpj"};